import { useState } from 'react';

import { useNewStrategyContext } from '../../NewStrategyContext';
import { SelectionButtonGroup } from '../../../Selection-button-group/Selection-button-group';
import { CreateStrategyAssetCategory } from '../../types';
import { useTranslation } from 'react-i18next';
import {
  ConnectionTypeEnum,
  StrategyAssetCategoryTypeEnum,
} from '../../../../constants/enums';

export const ChooseImportMode = () => {
  const { t } = useTranslation();
  const { dispatch } = useNewStrategyContext();

  const selectionList: CreateStrategyAssetCategory[] = Object.values(
    ConnectionTypeEnum
  ).map((value) => {
    const title = t(`strategies.chooseImportMode.${value}`);

    return { id: value, title, type: StrategyAssetCategoryTypeEnum.SYSTEM };
  });

  const [currentSelection, setCurrentSelection] =
    useState<CreateStrategyAssetCategory>(selectionList[0]);

  const handleSelection = (selection: CreateStrategyAssetCategory) => {
    setCurrentSelection(selection);
    dispatch({
      selectedConnectionType: selection.id as ConnectionTypeEnum,
    });
  };

  return (
    <div
      className={`
        flex
        flex-col
        w-full
        h-max
        py-4
        px-4
        my-auto
        items-center
        text-black
      `}
    >
      <div className="flex flex-col items-center justify-center w-full dark:text-white">
        <p className="font-semibold w-96 text-center text-2xl">
          {t('strategies.newStrategy.chooseImportMode.title')}
        </p>
        <SelectionButtonGroup
          className="mt-12 mb-4 w-96"
          cols={1}
          selectionList={selectionList}
          currentSelection={currentSelection}
          setCurrentSelection={handleSelection}
        />
      </div>
    </div>
  );
};
